import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import { nanoid } from 'nanoid';
import NApp from '../app/app.vue';
import NAvatar from '../avatar/avatar.vue';
import { AppMessage } from './message';
import { PropType } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'app-message',
  props: {
  message: {
    type: Object as PropType<AppMessage>,
    required: true,
  },
  brandColour: {
    type: String,
    default: '#062b80',
  },
  displayAvatar: {
    type: Boolean,
    default: false,
  },
  enableAvatarTooltip: {
    type: Boolean,
    default: false,
  },
  position: {
    type: String as PropType<'right' | 'left'>,
    default: 'right',
  },
  readonly: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;

const card = computed(() => {
  if (props.message.card) {
    const { content } = props.message.card;
    return {
      id: props.message.id ? props.message.id : nanoid(),
      content,
    };
  }
  return undefined;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["n-app-message", {
      'n-app-message--left': __props.position === 'left',
      'n-app-message--right': __props.position === 'right',
    }])
  }, [
    (__props.displayAvatar)
      ? (_openBlock(), _createBlock(NAvatar, {
          key: 0,
          size: "s",
          name: __props.message.name,
          imageUrl: __props.message.avatarUrl,
          enableTooltip: __props.enableAvatarTooltip,
          class: _normalizeClass(["n-app-message__avatar", {
        'n-app-message__avatar--left': __props.position === 'left',
        'n-app-message__avatar--right': __props.position === 'right',
      }])
        }, null, 8, ["name", "imageUrl", "enableTooltip", "class"]))
      : _createCommentVNode("", true),
    (card.value)
      ? (_openBlock(), _createBlock(NApp, {
          key: 1,
          colour: __props.brandColour,
          card: card.value,
          location: "conversation",
          readonly: __props.readonly,
          class: "n-app-message__card"
        }, null, 8, ["colour", "card", "readonly"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})